import { createClient } from "@supabase/supabase-js";
import CONFIG from "../../const/config.js";

export const dBClient = createClient(CONFIG.supabaseUrl, CONFIG.supabaseSecretKey)

